module.exports = __webpack_public_path__ + "img/metaverse.d0522eb9.png";